export const FACULTYPORTAL_BASE_URL = window.location.origin;
